import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import i18n from '../utils/i18n';
import './styles/SimpleFormWrapper.scss';

const SimpleFormWrapper = ({
  title,
  subtitle,
  description,
  children,
  onButtonClick,
  buttonTitle,
  backendError,
  onLeftButtonClick,
  leftButtonContent,
  showForgotPasswordLink,
  goToForgotPasswordPage
}) => (
  <form onSubmit={ onButtonClick }>
    <div className="simple-form-container">
      <h1 className="header">
        {title}
      </h1>
      <h3 className="sub-header">
        {subtitle}
      </h3>
      <div className="description">
        {description}
      </div>
      <div className="form">
        <div className="fields-wrapper">
          {children}
          <div className="backend-error-wrapper">
            {backendError}
          </div>
          <div className="simple-form-button-wrapper">
            <Button
              text={ buttonTitle }
              onClick={ onButtonClick }
              buttonClass="btn-continue"
            />
            {leftButtonContent && (
              <div onClick={ onLeftButtonClick } className="left-btn">
                {leftButtonContent}
                <hr className="btn-underscore" />
              </div>
            )}
          </div>
          {showForgotPasswordLink && (
            <div onClick={ goToForgotPasswordPage } className="forgot-a-password">
              {i18n.t('registerLoginScreens.FORGOT_PASSWORD')}
              <hr className="btn-underscore" />
            </div>
          )}
          <button type="submit" hidden />
        </div>
      </div>
    </div>
  </form>
);

SimpleFormWrapper.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
  onButtonClick: PropTypes.func,
  buttonTitle: PropTypes.string,
  backendError: PropTypes.string,
  onLeftButtonClick: PropTypes.func,
  leftButtonContent: PropTypes.node,
  showForgotPasswordLink: PropTypes.bool,
  goToForgotPasswordPage: PropTypes.func
};

SimpleFormWrapper.defaultProps = {
  title: 'Title',
  subtitle: '',
  description: '',
  children: null,
  onButtonClick: () => {},
  buttonTitle: 'Button',
  backendError: '',
  onLeftButtonClick: () => {},
  leftButtonContent: null,
  showForgotPasswordLink: false,
  goToForgotPasswordPage: () => {}
};

export default SimpleFormWrapper;



// WEBPACK FOOTER //
// ./src/components/SimpleFormWrapper.js